import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import SelectField from '../../../../common/select_field';
import { getAllPodsState } from '../../../../../features/pod/get_all_pods';

const ProductPromotionsFilters = ({ onSelectPodChange }) => {
    const [podId, setPodId] = useState('none');
    const getAllPods = useSelector(getAllPodsState);

    const _onSelectPodChange = (event) => {
        const value = event.target.value;
        setPodId(value);
        onSelectPodChange(value === 'none' ? '' : value);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <SelectField
                size="small"
                label="Szukaj po podzie"
                value={ podId }
                onChange={ _onSelectPodChange }
                options={ [{
                    value: 'none',
                    label: 'Wszystkie punkty (pody)'
                }, ...getAllPods?.data?.map(pod => ({
                    value: pod?.id,
                    label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - ' + (pod?.device?.serviceId || 'brak urządzenia')
                }))] }
            />
        </Box>
    );
};

export default ProductPromotionsFilters;